import React from 'react';

const CustomerTable = ({ customers, heading, type }) => {
  return (
    <div className="customer-table-component">
      <div className="table-header">
        <h3 className={`table-title ${type === 1 ? 'title-warning' : 'title-danger'}`}>
          {heading}
        </h3>
      </div>
      
      <div className="table-responsive-wrapper">
        <table className="modern-table">
          <thead>
            <tr className={type === 1 ? 'header-warning' : 'header-danger'}>
              <th>#</th>
              <th>Customer Name</th>
              <th>Phone Number</th>
              {type === 1 ? (
                <th>Days Without Order</th>
              ) : (
                <th>Last Payment Date</th>
              )}
              {type === 1 ? (
                <th>Last Order Date</th>
              ) : (
                <th>Outstanding Balance</th>
              )}
            </tr>
          </thead>
          <tbody>
            {customers && customers.length > 0 ? (
              customers.map((customer, index) => (
                <tr key={index} className="table-row">
                  <td className="serial-number">{index + 1}</td>
                  <td className="customer-name">{customer.name}</td>
                  <td className="customer-phone">{customer.phone}</td>
                  {type === 1 ? (
                    <>
                      <td className="warning-text">
                        {customer.days_inactive} days
                      </td>
                      <td className="date-text">{customer.last_order_date}</td>
                    </>
                  ) : (
                    <>
                      <td className="danger-text">
                        {customer.last_payment_date} ({customer.days_since_last_payment} days)
                      </td>
                      <td className="balance-text">{customer.outstanding_balance}</td>
                    </>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="empty-state">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <style>{`
        .customer-table-component {
          width: 100%;
        }
        
        .table-header {
          margin-bottom: 20px;
          padding-bottom: 10px;
          border-bottom: 3px solid;
        }
        
        .table-header .title-warning {
          border-bottom-color: #ffc107;
          display: inline-block;
          padding-bottom: 5px;
        }
        
        .table-header .title-danger {
          border-bottom-color: #dc3545;
          display: inline-block;
          padding-bottom: 5px;
        }
        
        .table-title {
          font-size: 18px;
          font-weight: 600;
          margin: 0;
          color: #333;
          font-family: 'Noto Nastaliq Urdu', 'Arial', sans-serif;
        }
        
        .table-responsive-wrapper {
          overflow-x: auto;
          border-radius: 12px;
        }
        
        .modern-table {
          width: 100%;
          border-collapse: separate;
          border-spacing: 0;
          font-size: 14px;
        }
        
        .modern-table thead tr {
          background: linear-gradient(135deg, #f8f9fc 0%, #e9ecef 100%);
        }
        
        .modern-table th {
          padding: 14px 12px;
          text-align: left;
          font-weight: 600;
          font-size: 13px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          border-bottom: 2px solid;
        }
        
        .header-warning th {
          color: #856404;
          border-bottom-color: #ffc107;
        }
        
        .header-danger th {
          color: #721c24;
          border-bottom-color: #dc3545;
        }
        
        .modern-table td {
          padding: 12px;
          border-bottom: 1px solid #f0f0f0;
          color: #555;
        }
        
        .table-row {
          transition: all 0.2s ease;
        }
        
        .table-row:hover {
          background: #f8f9fc;
          transform: scale(1.01);
        }
        
        .serial-number {
          font-weight: 600;
          color: #1e3c72;
          width: 50px;
        }
        
        .customer-name {
          font-weight: 500;
          color: #333;
        }
        
        .customer-phone {
          font-family: monospace;
          font-size: 13px;
        }
        
        .warning-text {
          color: #ff9800;
          font-weight: 500;
        }
        
        .danger-text {
          color: #f44336;
          font-weight: 500;
        }
        
        .date-text {
          color: #666;
          font-size: 12px;
        }
        
        .balance-text {
          color: #4caf50;
          font-weight: 600;
        }
        
        .empty-state {
          text-align: center;
          padding: 40px !important;
          color: #999;
          font-size: 14px;
        }
        
        /* Responsive */
        @media (max-width: 768px) {
          .modern-table th,
          .modern-table td {
            padding: 10px 8px;
            font-size: 12px;
          }
          
          .table-title {
            font-size: 16px;
          }
        }
        
        /* Urdu Text Support */
        @media (min-width: 769px) {
          .table-title,
          .modern-table th,
          .modern-table td {
            font-family: 'Noto Nastaliq Urdu', 'Segoe UI', Arial, sans-serif;
          }
        }
      `}</style>
    </div>
  );
};

export default CustomerTable;